import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {ServiceContactElementaryRight} from '../../../bonding_shared/model/dictionary-ids';
import {AbstractGuard} from '../../../bonding_shared/components/abstract-guard';
import {LoggedUserService} from '../../../bonding_shared';

@Injectable()
export class ServiceContactsGuard extends AbstractGuard {
  constructor(loggedUserService: LoggedUserService, router: Router) {
    super(loggedUserService, router);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAnyRight(state.url, [
      ServiceContactElementaryRight.SERVICE_CONTACT_READ_ALL,
      ServiceContactElementaryRight.SERVICE_CONTACT_READ_POLICIES,
      ServiceContactElementaryRight.SERVICE_CONTACT_READ_ZSS,
      ServiceContactElementaryRight.SERVICE_CONTACT_READ_CLAIMS,
      ServiceContactElementaryRight.SERVICE_CONTACT_READ_COMPANIES,
      ServiceContactElementaryRight.SERVICE_CONTACT_READ_BONDING,
      ServiceContactElementaryRight.SERVICE_CONTACT_READ_FINANCE,
    ]);
  }
}
